export default "__VITE_ASSET__Di2iXogj__"